import React, { useState } from "react";
import "../css/Faqs.css";

const Faqs = () => {
  const faqData = [
    {
      q: "What makes EarthFit different?",
      a: "We focus on grounded, mindful training. Slow strength, breath-led mobility, sustainable conditioning, and deep recovery."
    },
    {
      q: "Do I need experience to join?",
      a: "Not at all. EarthFit training adapts to every level — beginner to advanced — with a focus on natural progression."
    },
    {
      q: "Are group classes included in plans?",
      a: "All plans include unlimited classes. Higher tiers offer deeper mobility programs and recovery sessions."
    },
    {
      q: "Do you offer personal coaching?",
      a: "Yes. Our Holistic+ plan includes 1-on-1 sessions along with custom program planning and advanced analytics."
    },
    {
      q: "Can I pause my membership?",
      a: "Yes, memberships can be paused for up to 60 days per year at no cost."
    }
  ];

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faqs5">

      {/* ================= HERO ================= */}
      <section className="fq-hero">
        <div className="fq-leaf"></div>
        <h1>Frequently Asked</h1>
        <p>Everything you need to move naturally and confidently.</p>
      </section>


      {/* ================= FAQ ACCORDION ================= */}
      <section className="fq-wrapper">

        {faqData.map((f, i) => (
          <div className="fq-item" key={i}>
            
            <div className="fq-q" onClick={() => toggleFAQ(i)}>
              <h3>{f.q}</h3>
              <span className={`icon ${openIndex === i ? "open" : ""}`}>⌄</span>
            </div>

            <div className={`fq-a ${openIndex === i ? "show" : ""}`}>
              <p>{f.a}</p>
            </div>

          </div>
        ))}

      </section>


      {/* ================= END PANEL ================= */}
      <section className="fq-end">
        <h2>Still Curious?</h2>
        <p>We’re here to help guide your natural fitness journey.</p>
      </section>

    </div>
  );
};

export default Faqs;
